var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([
		__webpack_require__.e(242),
		__webpack_require__.e(589)
	]).then(next);
};